import { withInstall } from '@vuemap/vue-amap-util'
import Scale from './Scale.vue'

export const ElAmapControlScale = withInstall(Scale)
export default ElAmapControlScale
